
import { TransactionForm } from "@/components/TransactionForm";

interface EditTransactionDialogProps {
  isOpen: boolean;
  transaction: any;
  onClose: () => void;
  onSuccess: () => void;
}

export function EditTransactionDialog({
  isOpen,
  transaction,
  onClose,
  onSuccess
}: EditTransactionDialogProps) {
  if (!isOpen || !transaction) return null;

  return (
    <div className="fixed inset-0 bg-black/70 backdrop-blur-sm z-50 flex items-center justify-center">
      <div 
        className="w-full h-full md:h-auto md:w-[90%] md:max-w-3xl md:rounded-xl bg-[#1A1F2C] overflow-hidden shadow-xl"
      >
        <div className="h-full flex flex-col">
          <div className="flex justify-between items-center p-4 border-b border-gray-700">
            <h2 className="text-xl font-bold text-white font-['Russo_One']">
              Editar Transação
            </h2>
            <button
              onClick={onClose}
              className="text-white/70 hover:text-white"
            >
              ✕
            </button>
          </div>
          <div className="flex-1 overflow-y-auto p-4">
            <TransactionForm 
              initialData={transaction}
              onSuccess={onSuccess}
              onCancel={onClose}
              isEditing={true}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
